import { isServer } from "../../../utils/server/isServer";

export const getLocalStorageValue = (key: string): null | string => {
  return !isServer() ? localStorage.getItem(key) : null;
}

export const setLocalStorageValueByKey = (key: string, value: string): null | void => {
  return !isServer() ? localStorage.setItem(key, value) : undefined;
};
